import { checkBeforeEnter } from '@/auth/utils';

export default [
    {
        path: '/maestros-de-datos',
        name: 'master-data-index',
        component: () => import('@/views/modules/master-data/master-data-index/MasterDataIndex.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Maestros de Datos',
            breadcrumb: [{
                text: 'Catálogos',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/maestros-de-datos/:catalog',
        name: 'master-data-detail',
        component: () => import('@/views/modules/master-data/master-data-detail/MasterDataDetail.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Maestros de Datos',
            breadcrumb: [{
                text: 'Catálogos',
                to: {
                    name: 'master-data-index',
                }
            },{
                text: 'Registros',
                active: true
            }],
            requiresAuth: true
        }
    }
]
